import { useBoolState } from '@eturi/react'
import LOGO from '@op/assets/logos/ourpact-logo-on-light.svg'
import cls from 'classnames'
import { EpSwitch } from './EpSwitch'

type LandingLogoProps = {
	readonly affiliateLogo?: Maybe<string>
	readonly className?: string
}

export const LandingLogo = ({ className, affiliateLogo }: LandingLogoProps) => {
	const LogoImg = <img src={LOGO} alt="OurPact Logo" />

	// Short-circuit before hooks, since the rest will be evaluated and the rest stripped when built.
	if (process.env.APP_ENV !== 'dev') {
		const AppLogo = <div className="landing-logos__app-logo">{LogoImg}</div>

		return (
			<header className={cls('landing-logos', affiliateLogo && 'landing-logos--affiliate')}>
				{affiliateLogo ?
					<>
						{AppLogo}
						<div className="landing-logos__divider" />
						<div className="landing-logos__affiliate-logo">
							<img src={affiliateLogo} alt="Affiliate Logo" />
						</div>
					</>
				:	AppLogo}
			</header>
		)
	}

	const [visible, openEpSwitch, closeEpSwitch] = useBoolState(false)

	const EpSwitchLogo = (
		<div className="landing-logos__app-logo" onClick={openEpSwitch}>
			{LogoImg}
			{visible && <EpSwitch onClose={closeEpSwitch} />}
		</div>
	)

	if (!affiliateLogo) return <header className={className}>{EpSwitchLogo}</header>

	return (
		<header
			className={cls('landing-logos', affiliateLogo && 'landing-logos--affiliate', className)}
		>
			{affiliateLogo ?
				<>
					{EpSwitchLogo}
					<div className="landing-logos__divider" />
					<div className="landing-logos__affiliate-logo">
						<img src={affiliateLogo} alt="Affiliate Logo" />
					</div>
				</>
			:	EpSwitchLogo}
		</header>
	)
}
